export const seoConfig = {
  siteUrl: 'https://bytejourney.org',
  siteName: 'ByteJourney',
  defaultTitle: 'ByteJourney – Where Ideas Shape the Future of the Web',
  defaultDescription:
    'ByteJourney shares insights, strategies, and ideas on AI, SEO, and emerging technologies to navigate the digital landscape.',
  defaultImage: 'https://bytejourney.org/clear-image.png',
  locale: 'en_US',
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: seoConfig.siteName,
  url: seoConfig.siteUrl,
  description: seoConfig.defaultDescription,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${seoConfig.siteUrl}/?search={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};
